/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: tduzggWPyptPHtemkm2DXC
// Component: 2f7jdj06Y9Uk

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { LGPresetMessage } from "@lg-plus/landing-components/LGPresetMessage"; // plasmic-import: l7rnhcGMLMZI/codeComponent
import Header from "../../Header"; // plasmic-import: yynJwDHi6v6m/component
import Slider from "../../Slider"; // plasmic-import: ik3c6EOYMlYe/component
import SliderThumb from "../../SliderThumb"; // plasmic-import: yJwmeH6hDrX2/component
import MoneyToAccountTime from "../../MoneyToAccountTime"; // plasmic-import: VxkXyrb2gqH-/component
import { LGCTAButton } from "@lg-plus/landing-components"; // plasmic-import: lpGr0-fTWiXw/codeComponent
import PrimaryButton from "../../PrimaryButton"; // plasmic-import: JHLOdJoThInl/component
import { AntdAccordion } from "@plasmicpkgs/antd5/skinny/registerCollapse";
import { accordionHelpers as AntdAccordion_Helpers } from "@plasmicpkgs/antd5/skinny/registerCollapse";
import { AntdAccordionItem } from "@plasmicpkgs/antd5/skinny/registerCollapse";
import { SliderWrapper } from "@plasmicpkgs/react-slick";
import { sliderHelpers as SliderWrapper_Helpers } from "@plasmicpkgs/react-slick";
import ReviewCard from "../../ReviewCard"; // plasmic-import: zjdgGu7sRxbC/component
import SliderBtn from "../../SliderBtn"; // plasmic-import: 6V294JphE6RC/component
import Footer from "../../Footer"; // plasmic-import: FJohKF1WeTgo/component
import BackToTopStyled from "../../BackToTopStyled"; // plasmic-import: DjvhN87w1md0/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: tduzggWPyptPHtemkm2DXC/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: tduzggWPyptPHtemkm2DXC/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import sty from "./PlasmicHomepage.module.css"; // plasmic-import: 2f7jdj06Y9Uk/css

import CircleIcon from "./icons/PlasmicIcon__Circle"; // plasmic-import: UaxZXwuEYns1/icon
import ChevronDownIcon from "./icons/PlasmicIcon__ChevronDown"; // plasmic-import: N9NgtkGKC9Y5/icon

const emptyProxy: any = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q: any): any {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export type PageCtx = {
  pageRoute: string;
  pagePath: string;
  params: Record<string, string | string[] | undefined>;
  query: Record<string, string | string[] | undefined>;
};

export function generateDynamicMetadata($q: any, $ctx: PageCtx) {
  return {
    title: "NBN půjčka",
    description:
      "Půjčka, kterou dostanete rychle a snadno přímo na váš účet a to do 5 minut po schválení žádosti",
    openGraph: {
      title: "NBN půjčka",
      description:
        "Půjčka, kterou dostanete rychle a snadno přímo na váš účet a to do 5 minut po schválení žádosti"
    },
    twitter: {
      card: "summary" as const,
      title: "NBN půjčka",
      description:
        "Půjčka, kterou dostanete rychle a snadno přímo na váš účet a to do 5 minut po schválení žádosti"
    }
  };
}

createPlasmicElementProxy;

export type PlasmicHomepage__VariantMembers = {};
export type PlasmicHomepage__VariantsArgs = {};
type VariantPropType = keyof PlasmicHomepage__VariantsArgs;
export const PlasmicHomepage__VariantProps = new Array<VariantPropType>();

export type PlasmicHomepage__ArgsType = {};
type ArgPropType = keyof PlasmicHomepage__ArgsType;
export const PlasmicHomepage__ArgProps = new Array<ArgPropType>();

export type PlasmicHomepage__OverridesType = {
  homePageWrapper?: Flex__<"div">;
  lgPresetMessage?: Flex__<typeof LGPresetMessage>;
  header?: Flex__<typeof Header>;
  headerWrapper?: Flex__<"div">;
  link?: Flex__<"a"> & Partial<LinkProps>;
  amountCard?: Flex__<"div">;
  slider?: Flex__<typeof Slider>;
  moneyToAccountTime?: Flex__<typeof MoneyToAccountTime>;
  needsSection?: Flex__<"div">;
  h3?: Flex__<"h3">;
  faq?: Flex__<"div">;
  accordion?: Flex__<typeof AntdAccordion>;
  reviews?: Flex__<"section">;
  sliderCarousel?: Flex__<typeof SliderWrapper>;
  slide1?: Flex__<"div">;
  slide2?: Flex__<"div">;
  slide3?: Flex__<"div">;
  footer?: Flex__<typeof Footer>;
  backToTopStyled?: Flex__<typeof BackToTopStyled>;
};

export interface DefaultHomepageProps {}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicHomepage__RenderFunc(props: {
  variants: PlasmicHomepage__VariantsArgs;
  args: PlasmicHomepage__ArgsType;
  overrides: PlasmicHomepage__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "amount",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => 17000
      },
      {
        path: "slider.value",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $state.amount
      },
      {
        path: "accordion.activePanelId",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined,

        onMutate: generateOnMutateForSpec(
          "activePanelId",
          AntdAccordion_Helpers
        )
      },
      {
        path: "sliderCarousel.currentSlide",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => 0,

        refName: "sliderCarousel",
        onMutate: generateOnMutateForSpec("currentSlide", SliderWrapper_Helpers)
      }
    ],
    [$props, $ctx, $refs]
  );

  const globalVariants = _useGlobalVariants();

  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });

  const pageMetadata = generateDynamicMetadata(
    wrapQueriesWithLoadingProxy({}),
    $ctx as PageCtx
  );

  const styleTokensClassNames = _useStyleTokens();

  return (
    <React.Fragment>
      <Head>
        <meta name="twitter:card" content="summary" />
        <title key="title">{pageMetadata.title}</title>
        <meta key="og:title" property="og:title" content={pageMetadata.title} />
        <meta
          key="twitter:title"
          property="twitter:title"
          content={pageMetadata.title}
        />
        <meta
          key="description"
          property="description"
          content={pageMetadata.description}
        />
        <meta
          key="og:description"
          property="og:description"
          content={pageMetadata.description}
        />
        <meta
          key="twitter:description"
          property="twitter:description"
          content={pageMetadata.description}
        />
      </Head>

      <style>{`
        body {
          margin: 0;
        }
      `}</style>

      <div className={"plasmic_page_wrapper"}>
        <div
          data-plasmic-name={"homePageWrapper"}
          data-plasmic-override={overrides.homePageWrapper}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            "all",
            "root_reset_tduzggWPyptPHtemkm2DXC",
            "plasmic_default_styles",
            "plasmic_mixins",
            styleTokensClassNames,
            sty.homePageWrapper,
            {
              [sty.homePageWrapperglobal_themeOrange_override]: hasVariant(
                globalVariants,
                "themeOrange",
                "override"
              ),
              [sty.homePageWrapperglobal_themePurpleDark_override]: hasVariant(
                globalVariants,
                "themePurpleDark",
                "override"
              )
            }
          )}
        >
          <LGPresetMessage
            data-plasmic-name={"lgPresetMessage"}
            data-plasmic-override={overrides.lgPresetMessage}
            className={classNames("__wab_instance", sty.lgPresetMessage, {
              [sty.lgPresetMessageglobal_themeOrange_override]: hasVariant(
                globalVariants,
                "themeOrange",
                "override"
              ),
              [sty.lgPresetMessageglobal_themePurpleDark_override]: hasVariant(
                globalVariants,
                "themePurpleDark",
                "override"
              )
            })}
            content={
              "Tento odkaz je neplatn\u00fd nebo jeho platnost vypr\u0161ela."
            }
            isDynamic={true}
            preset={"INVALID_LINK"}
          />

          <Header
            data-plasmic-name={"header"}
            data-plasmic-override={overrides.header}
            className={classNames("__wab_instance", sty.header, {
              [sty.headerglobal_themeOrange_override]: hasVariant(
                globalVariants,
                "themeOrange",
                "override"
              )
            })}
          />

          <div
            data-plasmic-name={"headerWrapper"}
            data-plasmic-override={overrides.headerWrapper}
            className={classNames("all", sty.headerWrapper, {
              [sty.headerWrapperglobal_themeOrange_override]: hasVariant(
                globalVariants,
                "themeOrange",
                "override"
              ),
              [sty.headerWrapperglobal_themePurpleDark_override]: hasVariant(
                globalVariants,
                "themePurpleDark",
                "override"
              )
            })}
          >
            <div className={classNames("all", sty.freeBox___44Gpa)}>
              <PlasmicLink__
                data-plasmic-name={"link"}
                data-plasmic-override={overrides.link}
                aria-label={"link to homepage"}
                className={classNames("all", "a", "a__tduzg", sty.link)}
                component={Link}
                href={`/`}
                legacyBehavior={false}
                platform={"nextjs"}
              >
                <PlasmicImg__
                  alt={""}
                  className={classNames(sty.img__jytEz, {
                    [sty.imgglobal_themeOrange_override__jytEZdYuRs]:
                      hasVariant(globalVariants, "themeOrange", "override")
                  })}
                  displayHeight={"auto"}
                  displayMaxHeight={"none"}
                  displayMaxWidth={"100%"}
                  displayMinHeight={"0"}
                  displayMinWidth={"0"}
                  displayWidth={"auto"}
                  loading={"lazy"}
                  src={
                    hasVariant(globalVariants, "themeOrange", "override")
                      ? {
                          src: "/plasmic/nebank/images/nbnpujcka1Svg.svg",
                          fullWidth: 188,
                          fullHeight: 31,
                          aspectRatio: undefined
                        }
                      : {
                          src: "/plasmic/nebank/images/nbnpujckaSvg.svg",
                          fullWidth: 165,
                          fullHeight: 25,
                          aspectRatio: undefined
                        }
                  }
                />
              </PlasmicLink__>
              <div
                className={classNames("all", "__wab_text", sty.text__oX0Gy, {
                  [sty.textglobal_themeOrange_override__oX0GydYuRs]: hasVariant(
                    globalVariants,
                    "themeOrange",
                    "override"
                  )
                })}
              >
                {hasVariant(globalVariants, "themeOrange", "override") ? (
                  <React.Fragment>
                    <span
                      className={
                        "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                      }
                      style={{ color: "var(--token-vISfe3LD6UI_)" }}
                    >
                      {"Rychl\u00e1 a bezpe\u010dn\u00e1"}
                    </span>
                    <React.Fragment>{"\n"}</React.Fragment>
                    <span
                      className={
                        "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                      }
                      style={{ color: "var(--token-C4tm1rXXqEGp)" }}
                    >
                      {"p\u016fj\u010dka na cokoliv"}
                    </span>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={
                        "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                      }
                      style={{ color: "var(--token-vISfe3LD6UI_)" }}
                    >
                      {"Rychl\u00e1 a bezpe\u010dn\u00e1"}
                    </span>
                    <React.Fragment>{"\n"}</React.Fragment>
                    <span
                      className={
                        "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                      }
                      style={{ color: "var(--token-AXJ8MZpUtydS)" }}
                    >
                      {"p\u016fj\u010dka na cokoliv"}
                    </span>
                  </React.Fragment>
                )}
              </div>
              <div
                data-plasmic-name={"amountCard"}
                data-plasmic-override={overrides.amountCard}
                className={classNames("all", sty.amountCard, {
                  [sty.amountCardglobal_themeOrange_override]: hasVariant(
                    globalVariants,
                    "themeOrange",
                    "override"
                  ),
                  [sty.amountCardglobal_themePurpleDark_override]: hasVariant(
                    globalVariants,
                    "themePurpleDark",
                    "override"
                  )
                })}
              >
                <div
                  className={classNames("all", "__wab_text", sty.text__pc3Kj, {
                    [sty.textglobal_themeOrange_override__pc3KjdYuRs]:
                      hasVariant(globalVariants, "themeOrange", "override")
                  })}
                >
                  {"Chci si p\u016fj\u010dit"}
                </div>
                <div
                  className={classNames("all", "__wab_text", sty.text__nnVyl, {
                    [sty.textglobal_themeOrange_override__nnVyldYuRs]:
                      hasVariant(globalVariants, "themeOrange", "override")
                  })}
                >
                  <React.Fragment>{`${new Intl.NumberFormat("cs-CZ").format($state.amount)} Kč`}</React.Fragment>
                </div>
                <Slider
                  data-plasmic-name={"slider"}
                  data-plasmic-override={overrides.slider}
                  className={classNames("__wab_instance", sty.slider, {
                    [sty.sliderglobal_themeOrange_override]: hasVariant(
                      globalVariants,
                      "themeOrange",
                      "override"
                    )
                  })}
                  maxValue={30000}
                  minValue={1000}
                  onChange={async (...eventArgs: any) => {
                    generateStateOnChangeProp($state, [
                      "slider",
                      "value"
                    ]).apply(null, eventArgs);

                    if (
                      eventArgs.length > 1 &&
                      eventArgs[1] &&
                      eventArgs[1]._plasmic_state_init_
                    ) {
                      return;
                    }

                    (async val => {
                      const $steps = {};

                      $steps["updateAmount"] = true
                        ? (() => {
                            const actionArgs = {
                              variable: {
                                objRoot: $state,
                                variablePath: ["amount"]
                              },
                              operation: 0,
                              value: $state.slider.value
                            };
                            return (({
                              variable,
                              value,
                              startIndex,
                              deleteCount
                            }) => {
                              if (!variable) {
                                return;
                              }
                              const { objRoot, variablePath } = variable;

                              $stateSet(objRoot, variablePath, value);
                              return value;
                            })?.apply(null, [actionArgs]);
                          })()
                        : undefined;
                      if (
                        $steps["updateAmount"] != null &&
                        typeof $steps["updateAmount"] === "object" &&
                        typeof $steps["updateAmount"].then === "function"
                      ) {
                        $steps["updateAmount"] = await $steps["updateAmount"];
                      }
                    }).apply(null, eventArgs);
                  }}
                  step={1000}
                  value={generateStateValueProp($state, ["slider", "value"])}
                />

                <MoneyToAccountTime
                  data-plasmic-name={"moneyToAccountTime"}
                  data-plasmic-override={overrides.moneyToAccountTime}
                  className={classNames(
                    "__wab_instance",
                    sty.moneyToAccountTime,
                    {
                      [sty.moneyToAccountTimeglobal_themeOrange_override]:
                        hasVariant(globalVariants, "themeOrange", "override"),
                      [sty.moneyToAccountTimeglobal_themePurpleDark_override]:
                        hasVariant(
                          globalVariants,
                          "themePurpleDark",
                          "override"
                        )
                    }
                  )}
                />

                <div className={classNames("all", sty.freeBox___3VAid)}>
                  <div
                    className={classNames(
                      "all",
                      "__wab_text",
                      sty.text__n28Fs,
                      {
                        [sty.textglobal_themeOrange_override__n28FsdYuRs]:
                          hasVariant(globalVariants, "themeOrange", "override"),
                        [sty.textglobal_themePurpleDark_override__n28FsLKfzf]:
                          hasVariant(
                            globalVariants,
                            "themePurpleDark",
                            "override"
                          )
                      }
                    )}
                  >
                    {
                      "Ide\u00e1ln\u00ed p\u016fj\u010dka na\u0161ich z\u00e1kazn\u00edk\u016f je 20 000 K\u010d v d\u00e9lce od 3 do 36 m\u011bs\u00edc\u016f, s \u00farokem 2,99 % p. a., Max. RPSN 4,39 %. M\u011bs\u00ed\u010dn\u00ed spl\u00e1tka 594 K\u010d. Celkem k zaplacen\u00ed 24 967 K\u010d. V\u00fdpo\u010det je pouze ilustrativn\u00ed, kone\u010dn\u00fd \u00farok ur\u010d\u00ed poskytovatel."
                    }
                  </div>
                </div>
                <div
                  className={classNames("all", sty.freeBox__otLop, {
                    [sty.freeBoxglobal_themeOrange_override__otLopdYuRs]:
                      hasVariant(globalVariants, "themeOrange", "override")
                  })}
                >
                  <LGCTAButton
                    amount={$state.amount}
                    buttonSlot={
                      <PrimaryButton
                        className={classNames(
                          "__wab_instance",
                          sty.primaryButton__ydHc8,
                          {
                            [sty.primaryButtonglobal_themeOrange_override__ydHc8DYuRs]:
                              hasVariant(
                                globalVariants,
                                "themeOrange",
                                "override"
                              )
                          }
                        )}
                        color={
                          hasVariant(globalVariants, "themeOrange", "override")
                            ? undefined
                            : undefined
                        }
                        label={
                          <div
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.text__vOlnr,
                              {
                                [sty.textglobal_themeOrange_override__vOlnrdYuRs]:
                                  hasVariant(
                                    globalVariants,
                                    "themeOrange",
                                    "override"
                                  )
                              }
                            )}
                          >
                            {"Z\u00cdSKAT PEN\u00cdZE"}
                          </div>
                        }
                        roundedFull={true}
                      />
                    }
                    className={classNames(
                      "__wab_instance",
                      sty.lgctaButton__oN1W3
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            data-plasmic-name={"needsSection"}
            data-plasmic-override={overrides.needsSection}
            className={classNames("all", sty.needsSection, {
              [sty.needsSectionglobal_themeOrange_override]: hasVariant(
                globalVariants,
                "themeOrange",
                "override"
              ),
              [sty.needsSectionglobal_themePurpleDark_override]: hasVariant(
                globalVariants,
                "themePurpleDark",
                "override"
              )
            })}
          >
            <h3
              data-plasmic-name={"h3"}
              data-plasmic-override={overrides.h3}
              className={classNames(
                "all",
                "h3",
                "h3__tduzg",
                "__wab_text",
                sty.h3,
                {
                  [sty.h3global_themeOrange_override]: hasVariant(
                    globalVariants,
                    "themeOrange",
                    "override"
                  ),
                  [sty.h3global_themePurpleDark_override]: hasVariant(
                    globalVariants,
                    "themePurpleDark",
                    "override"
                  )
                }
              )}
            >
              {hasVariant(globalVariants, "themePurpleDark", "override") ? (
                <React.Fragment>
                  <span
                    className={
                      "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                    }
                    style={{ color: "var(--token-AXJ8MZpUtydS)" }}
                  >
                    {"Pen\u00edze na \u00fa\u010det"}
                  </span>
                  <React.Fragment>{"\n"}</React.Fragment>
                  <span
                    className={
                      "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                    }
                    style={{ color: "var(--token-vISfe3LD6UI_)" }}
                  >
                    {"Rychle a snadno"}
                  </span>
                </React.Fragment>
              ) : hasVariant(globalVariants, "themeOrange", "override") ? (
                <React.Fragment>
                  <span
                    className={
                      "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                    }
                    style={{ color: "var(--token-C4tm1rXXqEGp)" }}
                  >
                    {"Pen\u00edze na \u00fa\u010det"}
                  </span>
                  <React.Fragment>{"\n"}</React.Fragment>
                  <span
                    className={
                      "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                    }
                    style={{ color: "var(--token-5o5eLa3fobxR)" }}
                  >
                    {"Rychle a snadno"}
                  </span>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <span
                    className={
                      "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                    }
                    style={{ color: "var(--token-AXJ8MZpUtydS)" }}
                  >
                    {"Pen\u00edze na \u00fa\u010det"}
                  </span>
                  <React.Fragment>{"\n"}</React.Fragment>
                  <span
                    className={
                      "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                    }
                    style={{ color: "var(--token-5o5eLa3fobxR)" }}
                  >
                    {"Rychle a snadno"}
                  </span>
                </React.Fragment>
              )}
            </h3>
            <div
              className={classNames("all", sty.freeBox__rQHde, {
                [sty.freeBoxglobal_themeOrange_override__rQHdedYuRs]:
                  hasVariant(globalVariants, "themeOrange", "override")
              })}
            >
              <div
                className={classNames("all", sty.freeBox__nWhmp, {
                  [sty.freeBoxglobal_themeOrange_override__nWhmpdYuRs]:
                    hasVariant(globalVariants, "themeOrange", "override")
                })}
              >
                <div className={classNames("all", sty.freeBox__wkL1F)}>
                  <div className={classNames("all", sty.freeBox__ckQke)}>
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__kdJh3, {
                        [sty.imgglobal_themeOrange_override__kdJh3DYuRs]:
                          hasVariant(globalVariants, "themeOrange", "override")
                      })}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"lazy"}
                      src={
                        hasVariant(globalVariants, "themeOrange", "override")
                          ? {
                              src: "/plasmic/nebank/images/iconStopwatch1Svg.svg",
                              fullWidth: 50,
                              fullHeight: 50,
                              aspectRatio: undefined
                            }
                          : {
                              src: "/plasmic/nebank/images/iconStopwatchSvg.svg",
                              fullWidth: 50,
                              fullHeight: 60,
                              aspectRatio: undefined
                            }
                      }
                    />
                  </div>
                  <div className={classNames("all", sty.freeBox__n23Av)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__aeu1B,
                        {
                          [sty.textglobal_themeOrange_override__aeu1BdYuRs]:
                            hasVariant(
                              globalVariants,
                              "themeOrange",
                              "override"
                            )
                        }
                      )}
                    >
                      <React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                          }
                          style={{ fontWeight: 700 }}
                        >
                          {"Do 5 minut"}
                        </span>
                        <React.Fragment>
                          {" v\u00edte, jestli p\u016fj\u010dku dostanete"}
                        </React.Fragment>
                      </React.Fragment>
                    </div>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__uBc02,
                        {
                          [sty.textglobal_themeOrange_override__uBc02DYuRs]:
                            hasVariant(
                              globalVariants,
                              "themeOrange",
                              "override"
                            ),
                          [sty.textglobal_themePurpleDark_override__uBc02LKfzf]:
                            hasVariant(
                              globalVariants,
                              "themePurpleDark",
                              "override"
                            )
                        }
                      )}
                    >
                      {
                        "V\u00e1\u017e\u00edme si va\u0161eho \u010dasu, a proto rozhodneme o va\u0161\u00ed \u017e\u00e1dosti za mi\u0148 ne\u017e 5 minut."
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={classNames("all", sty.freeBox__bngDg, {
                  [sty.freeBoxglobal_themeOrange_override__bngDgdYuRs]:
                    hasVariant(globalVariants, "themeOrange", "override")
                })}
              >
                <div className={classNames("all", sty.freeBox__b24Ys)}>
                  <div className={classNames("all", sty.freeBox__gp4Wf)}>
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img___56JG6, {
                        [sty.imgglobal_themeOrange_override___56JG6DYuRs]:
                          hasVariant(globalVariants, "themeOrange", "override")
                      })}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"lazy"}
                      src={
                        hasVariant(globalVariants, "themeOrange", "override")
                          ? {
                              src: "/plasmic/nebank/images/iconSandwatch1Svg.svg",
                              fullWidth: 41,
                              fullHeight: 51,
                              aspectRatio: undefined
                            }
                          : {
                              src: "/plasmic/nebank/images/iconSandwatchSvg.svg",
                              fullWidth: 50,
                              fullHeight: 72,
                              aspectRatio: undefined
                            }
                      }
                    />
                  </div>
                  <div className={classNames("all", sty.freeBox__jk7Re)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__fUthd,
                        {
                          [sty.textglobal_themeOrange_override__fUthddYuRs]:
                            hasVariant(
                              globalVariants,
                              "themeOrange",
                              "override"
                            )
                        }
                      )}
                    >
                      <React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                          }
                          style={{ fontWeight: 700 }}
                        >
                          {"Nejjednodu\u0161\u0161\u00ed "}
                        </span>
                        <React.Fragment>{""}</React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                          }
                          style={{ fontWeight: 400 }}
                        >
                          {"\u017e\u00e1dost o p\u016fj\u010dku jen u n\u00e1s"}
                        </span>
                      </React.Fragment>
                    </div>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__w1Yo,
                        {
                          [sty.textglobal_themeOrange_override__w1YoDYuRs]:
                            hasVariant(
                              globalVariants,
                              "themeOrange",
                              "override"
                            ),
                          [sty.textglobal_themePurpleDark_override__w1YoLKfzf]:
                            hasVariant(
                              globalVariants,
                              "themePurpleDark",
                              "override"
                            )
                        }
                      )}
                    >
                      {
                        "P\u0159edschvalov\u00e1c\u00ed \u017e\u00e1dost o Obl\u00edbenou p\u016fj\u010dku zvl\u00e1dnete kompletn\u011b vyplnit za 1 minutu."
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={classNames("all", sty.freeBox___7Mc6P, {
                  [sty.freeBoxglobal_themeOrange_override___7Mc6PdYuRs]:
                    hasVariant(globalVariants, "themeOrange", "override")
                })}
              >
                <div className={classNames("all", sty.freeBox___9J0D)}>
                  <div className={classNames("all", sty.freeBox__iGwM)}>
                    <PlasmicImg__
                      alt={""}
                      className={classNames(sty.img__wxb2Y, {
                        [sty.imgglobal_themeOrange_override__wxb2YdYuRs]:
                          hasVariant(globalVariants, "themeOrange", "override")
                      })}
                      displayHeight={"auto"}
                      displayMaxHeight={"none"}
                      displayMaxWidth={"100%"}
                      displayMinHeight={"0"}
                      displayMinWidth={"0"}
                      displayWidth={"auto"}
                      loading={"lazy"}
                      src={
                        hasVariant(globalVariants, "themeOrange", "override")
                          ? {
                              src: "/plasmic/nebank/images/iconAlarm1Svg.svg",
                              fullWidth: 50,
                              fullHeight: 56,
                              aspectRatio: undefined
                            }
                          : {
                              src: "/plasmic/nebank/images/iconAlarmSvg.svg",
                              fullWidth: 50,
                              fullHeight: 55,
                              aspectRatio: undefined
                            }
                      }
                    />
                  </div>
                  <div className={classNames("all", sty.freeBox__f3La)}>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__opFhq,
                        {
                          [sty.textglobal_themeOrange_override__opFhQdYuRs]:
                            hasVariant(
                              globalVariants,
                              "themeOrange",
                              "override"
                            )
                        }
                      )}
                    >
                      <React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                          }
                          style={{ fontWeight: 400 }}
                        >
                          {"Pen\u00edze na \u00fa\u010det "}
                        </span>
                        <React.Fragment>{""}</React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                          }
                          style={{ fontWeight: 700 }}
                        >
                          {"ihned"}
                        </span>
                        <React.Fragment>{""}</React.Fragment>
                        <span
                          className={
                            "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                          }
                          style={{ fontWeight: 400 }}
                        >
                          {" po schv\u00e1len\u00ed"}
                        </span>
                      </React.Fragment>
                    </div>
                    <div
                      className={classNames(
                        "all",
                        "__wab_text",
                        sty.text__zOo9C,
                        {
                          [sty.textglobal_themeOrange_override__zOo9CdYuRs]:
                            hasVariant(
                              globalVariants,
                              "themeOrange",
                              "override"
                            ),
                          [sty.textglobal_themePurpleDark_override__zOo9CLKfzf]:
                            hasVariant(
                              globalVariants,
                              "themePurpleDark",
                              "override"
                            )
                        }
                      )}
                    >
                      {
                        "V\u00edme, \u017ee v\u017edycky jde o \u010das a proto pen\u00edze klient\u016fm pos\u00edl\u00e1me ihned po schv\u00e1len\u00ed."
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            data-plasmic-name={"faq"}
            data-plasmic-override={overrides.faq}
            className={classNames("all", sty.faq, {
              [sty.faqglobal_themeOrange_override]: hasVariant(
                globalVariants,
                "themeOrange",
                "override"
              ),
              [sty.faqglobal_themePurpleDark_override]: hasVariant(
                globalVariants,
                "themePurpleDark",
                "override"
              )
            })}
          >
            <div className={classNames("all", sty.freeBox___9Jdpz)}>
              <div
                className={classNames("all", "__wab_text", sty.text__lNpjG, {
                  [sty.textglobal_themeOrange_override__lNpjGdYuRs]: hasVariant(
                    globalVariants,
                    "themeOrange",
                    "override"
                  ),
                  [sty.textglobal_themePurpleDark_override__lNpjGlKfzf]:
                    hasVariant(globalVariants, "themePurpleDark", "override")
                })}
              >
                {hasVariant(globalVariants, "themePurpleDark", "override") ? (
                  <React.Fragment>
                    <span
                      className={
                        "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                      }
                      style={{ color: "var(--token-OPD4cQgbq3my)" }}
                    >
                      {"Nej\u010dast\u011bji"}
                    </span>
                    <React.Fragment> </React.Fragment>
                    <span
                      className={
                        "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                      }
                      style={{ color: "var(--token-vISfe3LD6UI_)" }}
                    >
                      {"kladen\u00e9 dotazy"}
                    </span>
                    <React.Fragment>{"\n"}</React.Fragment>
                    <span
                      className={
                        "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                      }
                      style={{ color: "var(--token-vISfe3LD6UI_)" }}
                    >
                      {"ohledn\u011b p\u016fj\u010dek"}
                    </span>
                  </React.Fragment>
                ) : hasVariant(globalVariants, "themeOrange", "override") ? (
                  <React.Fragment>
                    <span
                      className={
                        "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                      }
                      style={{ color: "var(--token-B6dlL7WETYo6)" }}
                    >
                      {"Nej\u010dast\u011bji"}
                    </span>
                    <React.Fragment>
                      {" kladen\u00e9 dotazy\nohledn\u011b p\u016fj\u010dek"}
                    </React.Fragment>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={
                        "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                      }
                      style={{ color: "var(--token-OPD4cQgbq3my)" }}
                    >
                      {"Nej\u010dast\u011bji"}
                    </span>
                    <React.Fragment>
                      {" kladen\u00e9 dotazy\nohledn\u011b p\u016fj\u010dek"}
                    </React.Fragment>
                  </React.Fragment>
                )}
              </div>
              {(() => {
                const child$Props = {
                  activeKey: generateStateValueProp($state, [
                    "accordion",
                    "activePanelId"
                  ]),
                  bordered: false,
                  className: classNames("__wab_instance", sty.accordion, {
                    [sty.accordionglobal_themeOrange_override]: hasVariant(
                      globalVariants,
                      "themeOrange",
                      "override"
                    ),
                    [sty.accordionglobal_themePurpleDark_override]: hasVariant(
                      globalVariants,
                      "themePurpleDark",
                      "override"
                    )
                  }),
                  disabled: false,
                  expandIcon: (
                    <CircleIcon
                      className={classNames("all", sty.svg__gBpWq)}
                      role={"img"}
                    />
                  ),

                  forceRender: true,
                  ghost: true,
                  items: (
                    <React.Fragment>
                      <AntdAccordionItem
                        className={classNames(
                          "__wab_instance",
                          sty.accordionItem___98M6R
                        )}
                        extra={
                          <React.Fragment>
                            {(() => {
                              try {
                                return $state.accordion.activePanelId !== "1";
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return true;
                                }
                                throw e;
                              }
                            })() ? (
                              <ChevronDownIcon
                                className={classNames("all", sty.svg__t6Sc5, {
                                  [sty.svgglobal_themeOrange_override__t6Sc5DYuRs]:
                                    hasVariant(
                                      globalVariants,
                                      "themeOrange",
                                      "override"
                                    )
                                })}
                                role={"img"}
                              />
                            ) : null}
                            {(() => {
                              try {
                                return $state.accordion.activePanelId === "1";
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return true;
                                }
                                throw e;
                              }
                            })() ? (
                              <ChevronDownIcon
                                className={classNames("all", sty.svg__vbqYo, {
                                  [sty.svgglobal_themeOrange_override__vbqYodYuRs]:
                                    hasVariant(
                                      globalVariants,
                                      "themeOrange",
                                      "override"
                                    )
                                })}
                                role={"img"}
                              />
                            ) : null}
                          </React.Fragment>
                        }
                        headerClass={classNames({
                          [sty["pcls_cOjkNNKL1GHd"]]: true
                        })}
                        id={"1"}
                        label2={
                          <div
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.text__xzZ1S,
                              {
                                [sty.textglobal_themeOrange_override__xzZ1SdYuRs]:
                                  hasVariant(
                                    globalVariants,
                                    "themeOrange",
                                    "override"
                                  ),
                                [sty.textglobal_themePurpleDark_override__xzZ1SlKfzf]:
                                  hasVariant(
                                    globalVariants,
                                    "themePurpleDark",
                                    "override"
                                  )
                              }
                            )}
                          >
                            {"Mohu si p\u016fj\u010dit na cokoliv?"}
                          </div>
                        }
                        showArrow={true}
                      >
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text___3Ojcn,
                            {
                              [sty.textglobal_themeOrange_override___3OjcndYuRs]:
                                hasVariant(
                                  globalVariants,
                                  "themeOrange",
                                  "override"
                                ),
                              [sty.textglobal_themePurpleDark_override___3OjcnLKfzf]:
                                hasVariant(
                                  globalVariants,
                                  "themePurpleDark",
                                  "override"
                                )
                            }
                          )}
                        >
                          <React.Fragment>
                            {
                              "Ano, můžete si půjčit na cokoliv, co potřebujete. Nezkoumáme účel vaší půjčky, a proto není nutné nám nic dokládat. Peníze můžete využít například na rekonstrukci bydlení, koupi automobilu, financování dovolené, nákup elektroniky, vzdělání nebo dokonce na konsolidaci stávajících dluhů. Rozhodnutí je jen na vás."
                            }
                          </React.Fragment>
                        </div>
                      </AntdAccordionItem>
                      <AntdAccordionItem
                        className={classNames(
                          "__wab_instance",
                          sty.accordionItem__q0Is
                        )}
                        extra={
                          <React.Fragment>
                            {(() => {
                              try {
                                return $state.accordion.activePanelId !== "2";
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return true;
                                }
                                throw e;
                              }
                            })() ? (
                              <ChevronDownIcon
                                className={classNames("all", sty.svg__iQi7E, {
                                  [sty.svgglobal_themeOrange_override__iQi7EdYuRs]:
                                    hasVariant(
                                      globalVariants,
                                      "themeOrange",
                                      "override"
                                    )
                                })}
                                role={"img"}
                              />
                            ) : null}
                            {(() => {
                              try {
                                return $state.accordion.activePanelId === "2";
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return true;
                                }
                                throw e;
                              }
                            })() ? (
                              <ChevronDownIcon
                                className={classNames("all", sty.svg__yu5ZF, {
                                  [sty.svgglobal_themeOrange_override__yu5ZFdYuRs]:
                                    hasVariant(
                                      globalVariants,
                                      "themeOrange",
                                      "override"
                                    )
                                })}
                                role={"img"}
                              />
                            ) : null}
                          </React.Fragment>
                        }
                        headerClass={classNames({
                          [sty["pcls_b-D1Gnyl9OwA"]]: true
                        })}
                        id={"2"}
                        label2={
                          <div
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.text__es7Rm,
                              {
                                [sty.textglobal_themeOrange_override__es7RmdYuRs]:
                                  hasVariant(
                                    globalVariants,
                                    "themeOrange",
                                    "override"
                                  ),
                                [sty.textglobal_themePurpleDark_override__es7RmLKfzf]:
                                  hasVariant(
                                    globalVariants,
                                    "themePurpleDark",
                                    "override"
                                  )
                              }
                            )}
                          >
                            {
                              "Co mus\u00edm spl\u0148ovat pro z\u00edsk\u00e1n\u00ed p\u016fj\u010dky?"
                            }
                          </div>
                        }
                        showArrow={true}
                      >
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__lUyhl,
                            {
                              [sty.textglobal_themeOrange_override__lUyhldYuRs]:
                                hasVariant(
                                  globalVariants,
                                  "themeOrange",
                                  "override"
                                ),
                              [sty.textglobal_themePurpleDark_override__lUyhlLKfzf]:
                                hasVariant(
                                  globalVariants,
                                  "themePurpleDark",
                                  "override"
                                )
                            }
                          )}
                        >
                          <React.Fragment>
                            {
                              "Pro získání půjčky je nutné splnit několik základních podmínek. Tato půjčka je určena občanům s trvalým pobytem na území České republiky, kteří mají pravidelný příjem a vlastní bankovní účet, na který budou finance vyplaceny. Důležité je také splňovat věkovou hranici, která je stanovena na 18 až 75 let. Kromě těchto podmínek je potřeba mít schopnost řádně splácet půjčku dle sjednaných podmínek."
                            }
                          </React.Fragment>
                        </div>
                      </AntdAccordionItem>
                      <AntdAccordionItem
                        className={classNames(
                          "__wab_instance",
                          sty.accordionItem__o1Osj
                        )}
                        extra={
                          <React.Fragment>
                            {(() => {
                              try {
                                return $state.accordion.activePanelId !== "3";
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return true;
                                }
                                throw e;
                              }
                            })() ? (
                              <ChevronDownIcon
                                className={classNames("all", sty.svg__yznlZ, {
                                  [sty.svgglobal_themeOrange_override__yznlZdYuRs]:
                                    hasVariant(
                                      globalVariants,
                                      "themeOrange",
                                      "override"
                                    )
                                })}
                                role={"img"}
                              />
                            ) : null}
                            {(() => {
                              try {
                                return $state.accordion.activePanelId === "3";
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return true;
                                }
                                throw e;
                              }
                            })() ? (
                              <ChevronDownIcon
                                className={classNames("all", sty.svg___3FW2C, {
                                  [sty.svgglobal_themeOrange_override___3FW2CdYuRs]:
                                    hasVariant(
                                      globalVariants,
                                      "themeOrange",
                                      "override"
                                    )
                                })}
                                role={"img"}
                              />
                            ) : null}
                          </React.Fragment>
                        }
                        headerClass={classNames({
                          [sty["pcls_v5VxkT8urVEH"]]: true
                        })}
                        id={"3"}
                        label2={
                          <div
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.text__iiIk,
                              {
                                [sty.textglobal_themeOrange_override__iiIKdYuRs]:
                                  hasVariant(
                                    globalVariants,
                                    "themeOrange",
                                    "override"
                                  ),
                                [sty.textglobal_themePurpleDark_override__iiIklKfzf]:
                                  hasVariant(
                                    globalVariants,
                                    "themePurpleDark",
                                    "override"
                                  )
                              }
                            )}
                          >
                            {
                              "Jsou s\u202fvy\u0159\u00edzen\u00edm p\u016fj\u010dky spojeny n\u011bjak\u00e9 poplatky?"
                            }
                          </div>
                        }
                        showArrow={true}
                      >
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__nw3PH,
                            {
                              [sty.textglobal_themeOrange_override__nw3PHdYuRs]:
                                hasVariant(
                                  globalVariants,
                                  "themeOrange",
                                  "override"
                                ),
                              [sty.textglobal_themePurpleDark_override__nw3PHlKfzf]:
                                hasVariant(
                                  globalVariants,
                                  "themePurpleDark",
                                  "override"
                                )
                            }
                          )}
                        >
                          <React.Fragment>
                            {
                              "Ne, za schválení půjčky se neplatí žádné poplatky. U nás neúčtujeme žádné skryté náklady za samotné podání žádosti nebo proces schválení. Můžete si být jisti, že celý proces je transparentní a všechny podmínky jsou předem jasně stanovené. Poplatky, pokud nějaké existují, se mohou vztahovat pouze na vedení úvěru, případné prodloužení splatnosti nebo jiné služby, které si dobrovolně zvolíte. Tyto poplatky jsou vždy uvedeny ve smlouvě, abyste měli přesný přehled o všech nákladech spojených s vaší půjčkou."
                            }
                          </React.Fragment>
                        </div>
                      </AntdAccordionItem>
                      <AntdAccordionItem
                        className={classNames(
                          "__wab_instance",
                          sty.accordionItem__zk8Za
                        )}
                        extra={
                          <React.Fragment>
                            {(() => {
                              try {
                                return $state.accordion.activePanelId !== "4";
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return true;
                                }
                                throw e;
                              }
                            })() ? (
                              <ChevronDownIcon
                                className={classNames("all", sty.svg__qhNo, {
                                  [sty.svgglobal_themeOrange_override__qhNodYuRs]:
                                    hasVariant(
                                      globalVariants,
                                      "themeOrange",
                                      "override"
                                    )
                                })}
                                role={"img"}
                              />
                            ) : null}
                            {(() => {
                              try {
                                return $state.accordion.activePanelId === "4";
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return true;
                                }
                                throw e;
                              }
                            })() ? (
                              <ChevronDownIcon
                                className={classNames("all", sty.svg__wNjRf, {
                                  [sty.svgglobal_themeOrange_override__wNjRfdYuRs]:
                                    hasVariant(
                                      globalVariants,
                                      "themeOrange",
                                      "override"
                                    )
                                })}
                                role={"img"}
                              />
                            ) : null}
                          </React.Fragment>
                        }
                        headerClass={classNames({
                          [sty["pcls_W8kmum48R3cF"]]: true
                        })}
                        id={"4"}
                        label2={
                          <div
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.text__hm8RS,
                              {
                                [sty.textglobal_themeOrange_override__hm8RSdYuRs]:
                                  hasVariant(
                                    globalVariants,
                                    "themeOrange",
                                    "override"
                                  ),
                                [sty.textglobal_themePurpleDark_override__hm8RSlKfzf]:
                                  hasVariant(
                                    globalVariants,
                                    "themePurpleDark",
                                    "override"
                                  )
                              }
                            )}
                          >
                            {
                              "Jak\u00e9 doklady mus\u00edm p\u0159edlo\u017eit, abych z\u00edskal/a p\u016fj\u010dku?"
                            }
                          </div>
                        }
                        showArrow={true}
                      >
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text___5KPzU,
                            {
                              [sty.textglobal_themeOrange_override___5KPzUdYuRs]:
                                hasVariant(
                                  globalVariants,
                                  "themeOrange",
                                  "override"
                                ),
                              [sty.textglobal_themePurpleDark_override___5KPzUlKfzf]:
                                hasVariant(
                                  globalVariants,
                                  "themePurpleDark",
                                  "override"
                                )
                            }
                          )}
                        >
                          <div
                            className={"__wab_expr_html_text"}
                            dangerouslySetInnerHTML={{
                              __html: `<div style="display: block;">
                                    Pro schválení půjčky je vždy nutné doložit několik základních dokumentů, které slouží k ověření vaší totožnosti a finanční situace. Patří mezi ně:
                                    <br>
                                    <ul>
                                        <li>Kopie platného občanského průkazu.</li>
                                        <li>Kopie druhého dokladu totožnosti (např. řidičský průkaz, cestovní pas nebo rodný list).</li>
                                        <li>Výplatní pásky za poslední 3 měsíce nebo výpisy z bankovního účtu za poslední 3 měsíce, které prokazují váš pravidelný příjem.</li>
                                    </ul>
                                    <br>
                                    Kromě těchto dokumentů může být v některých případech poskytovatelem půjčky vyžadováno také potvrzení o trvalém pobytu nebo doklad o vlastnictví bankovního účtu, na který budou peníze vyplaceny. Důležité je, aby všechny dokumenty byly aktuální, což urychlí proces schválení vaší půjčky.
                                </div>`
                            }}
                          />
                        </div>
                      </AntdAccordionItem>
                      <AntdAccordionItem
                        className={classNames(
                          "__wab_instance",
                          sty.accordionItem__iKaF
                        )}
                        extra={
                          <React.Fragment>
                            {(() => {
                              try {
                                return $state.accordion.activePanelId !== "5";
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return true;
                                }
                                throw e;
                              }
                            })() ? (
                              <ChevronDownIcon
                                className={classNames("all", sty.svg__vn3VO, {
                                  [sty.svgglobal_themeOrange_override__vn3VOdYuRs]:
                                    hasVariant(
                                      globalVariants,
                                      "themeOrange",
                                      "override"
                                    )
                                })}
                                role={"img"}
                              />
                            ) : null}
                            {(() => {
                              try {
                                return $state.accordion.activePanelId === "5";
                              } catch (e) {
                                if (
                                  e instanceof TypeError ||
                                  e?.plasmicType === "PlasmicUndefinedDataError"
                                ) {
                                  return true;
                                }
                                throw e;
                              }
                            })() ? (
                              <ChevronDownIcon
                                className={classNames("all", sty.svg__bbRXw, {
                                  [sty.svgglobal_themeOrange_override__bbRXwdYuRs]:
                                    hasVariant(
                                      globalVariants,
                                      "themeOrange",
                                      "override"
                                    )
                                })}
                                role={"img"}
                              />
                            ) : null}
                          </React.Fragment>
                        }
                        headerClass={classNames({
                          [sty["pcls_Ax9Vhpn243O6"]]: true
                        })}
                        id={"5"}
                        label2={
                          <div
                            className={classNames(
                              "all",
                              "__wab_text",
                              sty.text__cqHgC,
                              {
                                [sty.textglobal_themeOrange_override__cqHgCdYuRs]:
                                  hasVariant(
                                    globalVariants,
                                    "themeOrange",
                                    "override"
                                  ),
                                [sty.textglobal_themePurpleDark_override__cqHgClKfzf]:
                                  hasVariant(
                                    globalVariants,
                                    "themePurpleDark",
                                    "override"
                                  )
                              }
                            )}
                          >
                            {
                              "Dostanu p\u016fj\u010dku p\u0159\u00edmo od va\u0161\u00ed spole\u010dnosti?"
                            }
                          </div>
                        }
                        showArrow={true}
                      >
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__xutRe,
                            {
                              [sty.textglobal_themeOrange_override__xutREdYuRs]:
                                hasVariant(
                                  globalVariants,
                                  "themeOrange",
                                  "override"
                                ),
                              [sty.textglobal_themePurpleDark_override__xutRelKfzf]:
                                hasVariant(
                                  globalVariants,
                                  "themePurpleDark",
                                  "override"
                                )
                            }
                          )}
                        >
                          <React.Fragment>
                            {
                              "Naše společnost vystupuje jako zprostředkovatel mezi vámi a úvěrovými společnostmi, které vám mohou půjčku poskytnout. Po vyplnění žádosti odešleme váš požadavek několika úvěrovým společnostem a po obdržení odpovědí vás nasměrujeme na tu společnost, která má největší pravděpodobnost vám půjčku skutečně schválit."
                            }
                          </React.Fragment>
                        </div>
                      </AntdAccordionItem>
                    </React.Fragment>
                  ),
                  onChange: async (...eventArgs: any) => {
                    generateStateOnChangePropForCodeComponents(
                      $state,
                      "activePanelId",
                      ["accordion", "activePanelId"],
                      AntdAccordion_Helpers
                    ).apply(null, eventArgs);
                  },
                  rotateCustomExpandIcon: false,
                  rotationAngle: 8
                };
                initializeCodeComponentStates(
                  $state,
                  [
                    {
                      name: "activePanelId",
                      plasmicStateName: "accordion.activePanelId"
                    }
                  ],
                  [],
                  AntdAccordion_Helpers ?? {},
                  child$Props
                );

                return (
                  <AntdAccordion
                    data-plasmic-name={"accordion"}
                    data-plasmic-override={overrides.accordion}
                    {...child$Props}
                  />
                );
              })()}
            </div>
          </div>
          <section
            data-plasmic-name={"reviews"}
            data-plasmic-override={overrides.reviews}
            className={classNames("all", sty.reviews, {
              [sty.reviewsglobal_themeOrange_override]: hasVariant(
                globalVariants,
                "themeOrange",
                "override"
              ),
              [sty.reviewsglobal_themePurpleDark_override]: hasVariant(
                globalVariants,
                "themePurpleDark",
                "override"
              )
            })}
          >
            <div
              className={classNames("all", sty.freeBox__asAyR, {
                [sty.freeBoxglobal_themeOrange_override__asAyRdYuRs]:
                  hasVariant(globalVariants, "themeOrange", "override")
              })}
            >
              <div
                className={classNames("all", "__wab_text", sty.text__r27X, {
                  [sty.textglobal_themeOrange_override__r27XdYuRs]: hasVariant(
                    globalVariants,
                    "themeOrange",
                    "override"
                  ),
                  [sty.textglobal_themePurpleDark_override__r27XlKfzf]:
                    hasVariant(globalVariants, "themePurpleDark", "override")
                })}
              >
                {hasVariant(globalVariants, "themePurpleDark", "override") ? (
                  <React.Fragment>
                    <span
                      className={
                        "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                      }
                      style={{ color: "var(--token-AXJ8MZpUtydS)" }}
                    >
                      {"Co \u0159\u00edkaj\u00ed"}
                    </span>
                    <React.Fragment> </React.Fragment>
                    <span
                      className={
                        "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                      }
                      style={{ color: "var(--token-vISfe3LD6UI_)" }}
                    >
                      {"na\u0161i"}
                    </span>
                    <React.Fragment>{"\n"}</React.Fragment>
                    <span
                      className={
                        "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                      }
                      style={{ color: "var(--token-vISfe3LD6UI_)" }}
                    >
                      {"klienti"}
                    </span>
                  </React.Fragment>
                ) : hasVariant(globalVariants, "themeOrange", "override") ? (
                  <React.Fragment>
                    <span
                      className={
                        "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                      }
                      style={{ color: "var(--token-C4tm1rXXqEGp)" }}
                    >
                      {"Co \u0159\u00edkaj\u00ed"}
                    </span>
                    <React.Fragment>{" na\u0161i\nklienti"}</React.Fragment>
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <span
                      className={
                        "plasmic_default__all plasmic_default__span plasmic_default__span__tduzg"
                      }
                      style={{ color: "var(--token-AXJ8MZpUtydS)" }}
                    >
                      {"Co \u0159\u00edkaj\u00ed"}
                    </span>
                    <React.Fragment>{" na\u0161i\nklienti"}</React.Fragment>
                  </React.Fragment>
                )}
              </div>
              <div className={classNames("all", sty.freeBox__fyCFl)}>
                {(() => {
                  const child$Props = {
                    arrows: false,
                    beforeChange: async (...eventArgs: any) => {
                      generateStateOnChangePropForCodeComponents(
                        $state,
                        "currentSlide",
                        ["sliderCarousel", "currentSlide"],
                        SliderWrapper_Helpers
                      ).apply(null, eventArgs);
                    },
                    className: classNames(
                      "__wab_instance",
                      sty.sliderCarousel,
                      {
                        [sty.sliderCarouselglobal_themeOrange_override]:
                          hasVariant(globalVariants, "themeOrange", "override")
                      }
                    ),
                    draggable: false,
                    fade: true,
                    infinite: false,
                    initialSlide: generateStateValueProp($state, [
                      "sliderCarousel",
                      "currentSlide"
                    ]),
                    pauseOnHover: false,
                    ref: ref => {
                      $refs["sliderCarousel"] = ref;
                    },
                    sliderScopeClassName: sty["sliderCarousel__slider"],
                    swipe: false,
                    touchMove: false
                  };
                  initializeCodeComponentStates(
                    $state,
                    [
                      {
                        name: "currentSlide",
                        plasmicStateName: "sliderCarousel.currentSlide"
                      }
                    ],
                    [],
                    SliderWrapper_Helpers ?? {},
                    child$Props
                  );

                  return (
                    <SliderWrapper
                      data-plasmic-name={"sliderCarousel"}
                      data-plasmic-override={overrides.sliderCarousel}
                      {...child$Props}
                    >
                      <div
                        data-plasmic-name={"slide1"}
                        data-plasmic-override={overrides.slide1}
                        aria-label={"users-review"}
                        className={classNames("all", sty.slide1)}
                      >
                        <div
                          className={classNames("all", sty.freeBox__lwmZu, {
                            [sty.freeBoxglobal_themeOrange_override__lwmZudYuRs]:
                              hasVariant(
                                globalVariants,
                                "themeOrange",
                                "override"
                              )
                          })}
                        >
                          <ReviewCard
                            className={classNames(
                              "__wab_instance",
                              sty.reviewCard__hch8G,
                              {
                                [sty.reviewCardglobal_themeOrange_override__hch8GdYuRs]:
                                  hasVariant(
                                    globalVariants,
                                    "themeOrange",
                                    "override"
                                  )
                              }
                            )}
                          />

                          <ReviewCard
                            className={classNames(
                              "__wab_instance",
                              sty.reviewCard__ox7F
                            )}
                            img={{
                              src: "/plasmic/nebank/images/ondraPng.png",
                              fullWidth: 300,
                              fullHeight: 300,
                              aspectRatio: undefined
                            }}
                            name={"Ondra, 44"}
                            text={
                              "P\u0159ekvapilo m\u011b, jak snadn\u00e9 a transparentn\u00ed to bylo. \u017d\u00e1dn\u00e9 skryt\u00e9 poplatky, v\u0161e jasn\u00e9 a srozumiteln\u00e9. Doporu\u010duji v\u0161em v nouzi."
                            }
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"slide2"}
                        data-plasmic-override={overrides.slide2}
                        aria-label={"users-review slide2"}
                        className={classNames("all", sty.slide2)}
                      >
                        <div className={classNames("all", sty.freeBox__zqvw7)}>
                          <ReviewCard
                            className={classNames(
                              "__wab_instance",
                              sty.reviewCard__v1KBh
                            )}
                            img={{
                              src: "/plasmic/nebank/images/hanaPng.png",
                              fullWidth: 300,
                              fullHeight: 300,
                              aspectRatio: undefined
                            }}
                            name={"Hana, 51"}
                            text={
                              "Kdy\u017e jsem pot\u0159ebovala pen\u00edze nejv\u00edce, tato online p\u016fj\u010dka mi p\u0159i\u0161la jako z\u00e1chran\u00e1 brzda. Rychl\u00e1, jednoduch\u00e1 a bez stresu."
                            }
                          />

                          <ReviewCard
                            className={classNames(
                              "__wab_instance",
                              sty.reviewCard__ar7Sx
                            )}
                            img={{
                              src: "/plasmic/nebank/images/ottoPng.png",
                              fullWidth: 300,
                              fullHeight: 300,
                              aspectRatio: undefined
                            }}
                            name={"Otto, 46"}
                            text={
                              "Skv\u011bl\u00e1 zku\u0161enost! V\u0161e prob\u011bhlo hladce a komunikace byla na v\u00fdbornou. C\u00edt\u00edm se, jako bych z\u00edskal nov\u00e9ho finan\u010dn\u00edho partnera."
                            }
                          />
                        </div>
                      </div>
                      <div
                        data-plasmic-name={"slide3"}
                        data-plasmic-override={overrides.slide3}
                        aria-label={"users-review slide3"}
                        className={classNames("all", sty.slide3)}
                      >
                        <div
                          className={classNames("all", sty.freeBox__lbwsU, {
                            [sty.freeBoxglobal_themeOrange_override__lbwsUdYuRs]:
                              hasVariant(
                                globalVariants,
                                "themeOrange",
                                "override"
                              )
                          })}
                        >
                          <ReviewCard
                            className={classNames(
                              "__wab_instance",
                              sty.reviewCard__ejXwh,
                              {
                                [sty.reviewCardglobal_themeOrange_override__ejXwHdYuRs]:
                                  hasVariant(
                                    globalVariants,
                                    "themeOrange",
                                    "override"
                                  )
                              }
                            )}
                            img={{
                              src: "/plasmic/nebank/images/katkaPng.png",
                              fullWidth: 300,
                              fullHeight: 300,
                              aspectRatio: undefined
                            }}
                            name={"Katka, 62"}
                            text={
                              "P\u016fj\u010dka mi pomohla p\u0159eklenout t\u011b\u017ek\u00e9 obdob\u00ed. V\u0161e prob\u011bhlo rychle a bez zbyte\u010dn\u00fdch komplikac\u00ed. D\u00edky za pomoc!"
                            }
                          />

                          <ReviewCard
                            className={classNames(
                              "__wab_instance",
                              sty.reviewCard__sp1Ob,
                              {
                                [sty.reviewCardglobal_themeOrange_override__sp1OBdYuRs]:
                                  hasVariant(
                                    globalVariants,
                                    "themeOrange",
                                    "override"
                                  )
                              }
                            )}
                            img={{
                              src: "/plasmic/nebank/images/milosPng.png",
                              fullWidth: 300,
                              fullHeight: 300,
                              aspectRatio: undefined
                            }}
                            name={"Milo\u0161, 45"}
                            text={
                              "M\u011bl jsem ji\u017e zku\u0161enosti s online p\u016fj\u010dkami, ale tato byla zdaleka nejlep\u0161\u00ed. Rychl\u00e9 schv\u00e1len\u00ed a bez skryt\u00fdch poplatk\u016f."
                            }
                          />
                        </div>
                      </div>
                    </SliderWrapper>
                  );
                })()}
              </div>
              <div className={classNames("all", sty.freeBox__ao7Kc)}>
                <SliderBtn
                  className={classNames(
                    "__wab_instance",
                    sty.sliderBtn___0YMpr
                  )}
                  inactive={(() => {
                    try {
                      return $state.sliderCarousel.currentSlide !== 0;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return [];
                      }
                      throw e;
                    }
                  })()}
                  onClick={async () => {
                    const $steps = {};

                    $steps["updateSliderCarouselCurrentSlide"] = true
                      ? (() => {
                          const actionArgs = {
                            variable: {
                              objRoot: $state,
                              variablePath: ["sliderCarousel", "currentSlide"]
                            },
                            operation: 0,
                            value: 0
                          };
                          return (({
                            variable,
                            value,
                            startIndex,
                            deleteCount
                          }) => {
                            if (!variable) {
                              return;
                            }
                            const { objRoot, variablePath } = variable;

                            $stateSet(objRoot, variablePath, value);
                            return value;
                          })?.apply(null, [actionArgs]);
                        })()
                      : undefined;
                    if (
                      $steps["updateSliderCarouselCurrentSlide"] != null &&
                      typeof $steps["updateSliderCarouselCurrentSlide"] ===
                        "object" &&
                      typeof $steps["updateSliderCarouselCurrentSlide"].then ===
                        "function"
                    ) {
                      $steps["updateSliderCarouselCurrentSlide"] =
                        await $steps["updateSliderCarouselCurrentSlide"];
                    }
                  }}
                />

                <SliderBtn
                  className={classNames(
                    "__wab_instance",
                    sty.sliderBtn___98BZa
                  )}
                  inactive={(() => {
                    try {
                      return $state.sliderCarousel.currentSlide !== 1;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return [];
                      }
                      throw e;
                    }
                  })()}
                  onClick={async () => {
                    const $steps = {};

                    $steps["updateSliderCarouselCurrentSlide"] = true
                      ? (() => {
                          const actionArgs = {
                            variable: {
                              objRoot: $state,
                              variablePath: ["sliderCarousel", "currentSlide"]
                            },
                            operation: 0,
                            value: 1
                          };
                          return (({
                            variable,
                            value,
                            startIndex,
                            deleteCount
                          }) => {
                            if (!variable) {
                              return;
                            }
                            const { objRoot, variablePath } = variable;

                            $stateSet(objRoot, variablePath, value);
                            return value;
                          })?.apply(null, [actionArgs]);
                        })()
                      : undefined;
                    if (
                      $steps["updateSliderCarouselCurrentSlide"] != null &&
                      typeof $steps["updateSliderCarouselCurrentSlide"] ===
                        "object" &&
                      typeof $steps["updateSliderCarouselCurrentSlide"].then ===
                        "function"
                    ) {
                      $steps["updateSliderCarouselCurrentSlide"] =
                        await $steps["updateSliderCarouselCurrentSlide"];
                    }
                  }}
                />

                <SliderBtn
                  className={classNames("__wab_instance", sty.sliderBtn__fBjlj)}
                  inactive={(() => {
                    try {
                      return $state.sliderCarousel.currentSlide !== 2;
                    } catch (e) {
                      if (
                        e instanceof TypeError ||
                        e?.plasmicType === "PlasmicUndefinedDataError"
                      ) {
                        return [];
                      }
                      throw e;
                    }
                  })()}
                  onClick={async () => {
                    const $steps = {};

                    $steps["updateSliderCarouselCurrentSlide"] = true
                      ? (() => {
                          const actionArgs = {
                            variable: {
                              objRoot: $state,
                              variablePath: ["sliderCarousel", "currentSlide"]
                            },
                            operation: 0,
                            value: 2
                          };
                          return (({
                            variable,
                            value,
                            startIndex,
                            deleteCount
                          }) => {
                            if (!variable) {
                              return;
                            }
                            const { objRoot, variablePath } = variable;

                            $stateSet(objRoot, variablePath, value);
                            return value;
                          })?.apply(null, [actionArgs]);
                        })()
                      : undefined;
                    if (
                      $steps["updateSliderCarouselCurrentSlide"] != null &&
                      typeof $steps["updateSliderCarouselCurrentSlide"] ===
                        "object" &&
                      typeof $steps["updateSliderCarouselCurrentSlide"].then ===
                        "function"
                    ) {
                      $steps["updateSliderCarouselCurrentSlide"] =
                        await $steps["updateSliderCarouselCurrentSlide"];
                    }
                  }}
                />
              </div>
              <div className={classNames("all", sty.freeBox__qUkAe)}>
                <LGCTAButton
                  amount={$state.amount}
                  buttonSlot={
                    <PrimaryButton
                      className={classNames(
                        "__wab_instance",
                        sty.primaryButton___0JLWv,
                        {
                          [sty.primaryButtonglobal_themeOrange_override___0JLWvdYuRs]:
                            hasVariant(
                              globalVariants,
                              "themeOrange",
                              "override"
                            )
                        }
                      )}
                      color={
                        hasVariant(globalVariants, "themeOrange", "override")
                          ? undefined
                          : undefined
                      }
                      label={
                        <div
                          className={classNames(
                            "all",
                            "__wab_text",
                            sty.text__kn6Zo,
                            {
                              [sty.textglobal_themeOrange_override__kn6ZodYuRs]:
                                hasVariant(
                                  globalVariants,
                                  "themeOrange",
                                  "override"
                                )
                            }
                          )}
                        >
                          {"Z\u00cdSKAT PEN\u00cdZE"}
                        </div>
                      }
                      roundedFull={true}
                    />
                  }
                  className={classNames(
                    "__wab_instance",
                    sty.lgctaButton__fHGiv
                  )}
                  id={"cta-btn-2"}
                />
              </div>
            </div>
          </section>
          <Footer
            data-plasmic-name={"footer"}
            data-plasmic-override={overrides.footer}
            className={classNames("__wab_instance", sty.footer, {
              [sty.footerglobal_themeOrange_override]: hasVariant(
                globalVariants,
                "themeOrange",
                "override"
              ),
              [sty.footerglobal_themePurpleDark_override]: hasVariant(
                globalVariants,
                "themePurpleDark",
                "override"
              )
            })}
          />

          <BackToTopStyled
            data-plasmic-name={"backToTopStyled"}
            data-plasmic-override={overrides.backToTopStyled}
            className={classNames("__wab_instance", sty.backToTopStyled)}
          />
        </div>
      </div>
    </React.Fragment>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  homePageWrapper: [
    "homePageWrapper",
    "lgPresetMessage",
    "header",
    "headerWrapper",
    "link",
    "amountCard",
    "slider",
    "moneyToAccountTime",
    "needsSection",
    "h3",
    "faq",
    "accordion",
    "reviews",
    "sliderCarousel",
    "slide1",
    "slide2",
    "slide3",
    "footer",
    "backToTopStyled"
  ],
  lgPresetMessage: ["lgPresetMessage"],
  header: ["header"],
  headerWrapper: [
    "headerWrapper",
    "link",
    "amountCard",
    "slider",
    "moneyToAccountTime"
  ],
  link: ["link"],
  amountCard: ["amountCard", "slider", "moneyToAccountTime"],
  slider: ["slider"],
  moneyToAccountTime: ["moneyToAccountTime"],
  needsSection: ["needsSection", "h3"],
  h3: ["h3"],
  faq: ["faq", "accordion"],
  accordion: ["accordion"],
  reviews: ["reviews", "sliderCarousel", "slide1", "slide2", "slide3"],
  sliderCarousel: ["sliderCarousel", "slide1", "slide2", "slide3"],
  slide1: ["slide1"],
  slide2: ["slide2"],
  slide3: ["slide3"],
  footer: ["footer"],
  backToTopStyled: ["backToTopStyled"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  homePageWrapper: "div";
  lgPresetMessage: typeof LGPresetMessage;
  header: typeof Header;
  headerWrapper: "div";
  link: "a";
  amountCard: "div";
  slider: typeof Slider;
  moneyToAccountTime: typeof MoneyToAccountTime;
  needsSection: "div";
  h3: "h3";
  faq: "div";
  accordion: typeof AntdAccordion;
  reviews: "section";
  sliderCarousel: typeof SliderWrapper;
  slide1: "div";
  slide2: "div";
  slide3: "div";
  footer: typeof Footer;
  backToTopStyled: typeof BackToTopStyled;
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHomepage__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHomepage__VariantsArgs;
    args?: PlasmicHomepage__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicHomepage__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicHomepage__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHomepage__ArgProps,
          internalVariantPropNames: PlasmicHomepage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomepage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "homePageWrapper") {
    func.displayName = "PlasmicHomepage";
  } else {
    func.displayName = `PlasmicHomepage.${nodeName}`;
  }
  return func;
}

export const PlasmicHomepage = Object.assign(
  // Top-level PlasmicHomepage renders the root element
  makeNodeComponent("homePageWrapper"),
  {
    // Helper components rendering sub-elements
    lgPresetMessage: makeNodeComponent("lgPresetMessage"),
    header: makeNodeComponent("header"),
    headerWrapper: makeNodeComponent("headerWrapper"),
    link: makeNodeComponent("link"),
    amountCard: makeNodeComponent("amountCard"),
    slider: makeNodeComponent("slider"),
    moneyToAccountTime: makeNodeComponent("moneyToAccountTime"),
    needsSection: makeNodeComponent("needsSection"),
    h3: makeNodeComponent("h3"),
    faq: makeNodeComponent("faq"),
    accordion: makeNodeComponent("accordion"),
    reviews: makeNodeComponent("reviews"),
    sliderCarousel: makeNodeComponent("sliderCarousel"),
    slide1: makeNodeComponent("slide1"),
    slide2: makeNodeComponent("slide2"),
    slide3: makeNodeComponent("slide3"),
    footer: makeNodeComponent("footer"),
    backToTopStyled: makeNodeComponent("backToTopStyled"),

    // Metadata about props expected for PlasmicHomepage
    internalVariantProps: PlasmicHomepage__VariantProps,
    internalArgProps: PlasmicHomepage__ArgProps,

    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/",
      pagePath: "/",
      params: {},
      query: {}
    })
  }
);

export default PlasmicHomepage;
/* prettier-ignore-end */
